export const subDomainError = "Subdomain is not available please try another one";